
import IconLanguage from '@/components/IconLanguage/index.vue';

export default {
  components: {
    IconLanguage: IconLanguage
  },
  props: {
    languages: {
      type: Array,
      required: true
    },

    language: {
      type: [Number, String],
      required: true
    },

    addValidator: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      model: {
        language: this.language
      },
      config: {
        labelPosition: 'left',
        inline: true
      },
      rules: {
        language: [{ required: true }]
      }
    };
  },


  watch: {
    language: function language(val) {
      this.model.language = val;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$refs.form && _this.$refs.form.validate && _this.addValidator(_this.$refs.form.validate);
    });
  },


  methods: {
    handleChange: function handleChange(val) {
      this.$emit('select', val);
    },
    handleDelete: function handleDelete(val) {
      this.$emit('delete', val);
    }
  }
};